declare global {
  interface Window {
    _hsq: any;
  }
}

export const loadHubSpot = () => {
  if (document.getElementById('hs-script-loader')) {
    return;
  }

  const hubSpotScript = document.createElement('script');
  hubSpotScript.defer = true;
  hubSpotScript.async = true;

  hubSpotScript.id = 'hs-script-loader';
  hubSpotScript.src = '//js.hs-scripts.com/50420967.js';

  document.body.appendChild(hubSpotScript);
};

export type HubSpotEvent = [event: string, payload?: Record<string, unknown>];

export const fireHubSpotEvents = (events: HubSpotEvent[]) => {
  if (window._hsq) {
    events.forEach((event) => {
      window._hsq.push(event);
    });
  }
};
